<div class="flex column align-items-center step-layout">
  <div class="step-layout__content">
    <div class="flex column align-items-center gap-32">
      <div class="flex column align-items-center gap-4">
        <span class="typo-title-3 p-4">Seed Passphrase</span>
        <span class="typo-text-2 text-medium text-align-center"
          >Add an optional passphrase for extra security.
          <strong>This is different from your wallet password.</strong></span
        >
      </div>

      <div class="flex column align-items-center gap-16 full-width">
        <div class="full-width">
          <kc-input
            [infoLabel]="{ label: 'Seed Passphrase (optional)' }"
            [type]="'password'"
            [placeholder]="'Enter passphrase'"
            [ngModel]="seedPassphrase()"
            (valueChange)="onSeedPassphraseChange($any($event))"
          />

          <div class="full-width text-gray-60 typo-text-2 pt-8">
            Adding a passphrase provides an additional layer of security. If you
            set one, you'll need it together with your recovery phrase to
            restore your wallet.
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="step-layout__buttons">
    <div class="flex full-width gap-16">
      <div class="full-width">
        <kc-button
          [isFullWidth]="true"
          [variant]="'secondary'"
          [text]="'Back'"
          (buttonClick)="onBack()"
        />
      </div>
      <div class="full-width">
        <kc-button
          [isFullWidth]="true"
          [text]="'Continue'"
          (buttonClick)="onContinue()"
        />
      </div>
    </div>
  </div>
</div>
